import React from 'react';
import { NewsletterForm } from '../ui/NewsletterForm';
import { useLocation, useNavigate } from 'react-router-dom';
import { IconMailFilled, IconMapPinFilled, IconPhoneFilled } from '@tabler/icons-react';

export const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isperungudi = location.pathname === '/perungudi-chennai' || location.pathname === '/affordable-coworking-space-perungudi' || location.pathname === '/virtual-office-perungudi';


  const scrollToSection = (target) => {
    const element = document.getElementById(target);
    if (element) {
      const headerHeight = 105;
      const elementPosition = element.offsetTop - headerHeight;

      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth'
      });
    }
  };
  return (
    <footer className="items-stretch w-full flex flex-col overflow-hidden bg-white pt-4 pb-[21px] px-16 max-md:max-w-full max-md:px-5">
      <div className="self-center flex w-full max-w-[1312px] gap-[40px_128px] flex-wrap bg-[#966376] p-12 rounded-[48px] max-md:max-w-full max-md:px-5">
        <div className="min-w-60 text-sm w-[500px] max-md:max-w-full">
          <img
            style={{ filter: 'brightness(100)' }}
            src="https://cdn.builder.io/api/v1/image/assets/156ea696819743bb881fd4ebbe99ea1e/77fb845f590862cde7b4672edd0204c364008f03?placeholderIfAbsent=true"
            alt="Offis Bay Logo"
            className="aspect-[4.15] object-contain w-[150px] sm:w-[187px] max-w-full"
          />
          <ul className=" mt-8 flex-col gap-2">
            <li className="flex flex-row pt-2 gap-2 text-[0.8rem] items-start">
              <IconMapPinFilled
                size={25}
                className=" stroke-white fill-primary"
              />
              <span className='text-white'>
                {isperungudi ? "Plot# 23A1 Venkateshwara Colony, 3rd Cross Street, Nehru Nagar, Chennai – 600041" : "#191, 3rd Floor, Hamid Building, Whites Road, Anna Salai, Chennai – 600006."}
              </span>
            </li>
            <li className="flex flex-row pt-2 gap-2 text-[0.8rem] items-center">
              <IconPhoneFilled
                size={23}
                className=" stroke-white fill-primary"
              />
              <a className='text-white' href="tel:+919600466139">+91 9363049029 / +91 7708086301</a>
            </li>
            <li className="flex flex-row pt-2 gap-2 text-[0.8rem] items-center">
              <IconMailFilled
                size={23}
                className=" stroke-white fill-primary"
              />
              <a className='text-white' href="mailto:reachus@offisbay.com">reachus@offisbay.com</a>
            </li>
          </ul>
        </div>

        <div className="flex min-w-60 gap-10 text-white flex-wrap flex-1 shrink basis-[0%] max-md:max-w-full">
          {
            !location.pathname.includes('/virtual-office-') && (
              <div className="overflow-hidden items-center text-xs font-semibold uppercase flex-1 shrink basis-[0%] flex flex-col gap-4">
                <button onClick={() => scrollToSection('amenities')} className="w-fit text-white hover:text-gray-200 transition-colors py-2 px-4">
                  Amenities
                </button>
                <button onClick={() => navigate(isperungudi ? "/virtual-office-perungudi" : '/virtual-office-chennai')} className="w-fit text-white hover:text-gray-200 transition-colors py-2 px-4">
                  Virtual Tour
                </button>
              </div>
            )
          }

          <div className="flex-1 shrink basis-[0%]">
            <h4 className="text-white text-xs font-semibold uppercase">Follow Us</h4>
            <nav className="w-full text-sm font-normal whitespace-nowrap leading-[25px] mt-4">
              <a href="https://www.facebook.com/people/Offis-Bay/61553566943470/?mibextid=ZbWKwL" target="_blank" rel="noopener noreferrer" className="text-white block py-2 hover:text-gray-200">Facebook</a>
              <a href="https://www.instagram.com/offisbay/" target="_blank" rel="noopener noreferrer" className="text-white block py-2 hover:text-gray-200">Instagram</a>
              <a href="https://x.com/OffisBay" target="_blank" rel="noopener noreferrer" className="text-white block py-2 hover:text-gray-200">X</a>
              <a href="https://www.linkedin.com/company/offis-bay/" target="_blank" rel="noopener noreferrer" className="text-white block py-2 hover:text-gray-200">LinkedIn</a>
            </nav>
          </div>
        </div>
      </div>
      <div className="w-full text-sm text-[#1D1E1C] font-normal mt-4 px-4">
        <div className="flex flex-wrap flex-col md:flex-row md:justify-between gap-4 md:gap-[40px_100px]">
          <div className="text-[#1D1E1C] leading-[22px] text-center md:text-left text-xs md:text-sm">
            © 2025 Offis Bay. All rights reserved.
          </div>
          <div className="text-[#1D1E1C] leading-[22px] text-center md:text-left text-xs md:text-sm">
            Designed and Developed by @Cruxcreations
          </div>
          <div className="flex justify-center md:justify-start gap-4 underline text-xs md:text-sm">
            <a href="/privacy-policy" className="text-[#1D1E1C] hover:text-[#966376]">
              Privacy Policy
            </a>
            <a href="/terms-and-conditions" className="text-[#1D1E1C] hover:text-[#966376]">
              Terms of Service
            </a>
          </div>
        </div>
      </div>

    </footer>
  );
};
